Customer.Users ||= {}

class Customer.Users.ProfileMainView extends Backbone.View
  template: JST["backbone/templates/customer/users/user_profile"]

  id: 'main-profile'
  className: 'tab-pane active nano container-fluid'

  initialize: (@options = {}) ->
    @source = @options.source
    @profile = @options.profile
    @socialId = @options.ticket_social_user_id
    @socialUsers = @_orderSocialUsers(@options.social_users)
    @editableAttributes = @options.editable_attributes
    @searchQuery = @options.search_query
    @editing = false

  render: ->
    @$el.html(@template({
      source: @source
      profile: @profile
      socialUsers: @socialUsers
      getSocialUserType: @getSocialUserType
      name: @_getName()
    }))

    @profileAttributesView = new Customer.Users.ProfilePreviewAttributesView(
      profile: @profile,
      social_users: @socialUsers,
      attribute_definitions: @editableAttributes,
      get_social_user_type: @getSocialUserType,
      ticket_social_user_id: @socialId
    )
    @$el.find('.main-profile-left-column').append(@profileAttributesView.render().el)
    @listenTo(@profileAttributesView, 'updateName', @updateName)
    @listenTo(@profileAttributesView, 'profile:social-user-removed', (response)=>
      @unmergeSuccess(response))
    @listenTo @profileAttributesView, 'profile_custom_attributes:change', (response) =>
      @trigger 'profile_custom_attributes:change', response
    @listenTo @profileAttributesView, 'profile_custom_attributes:restore', =>
      @trigger 'profile_custom_attributes:restore'

    @profileTagsView = new Customer.Users.ProfileTagsView(profile: @profile)
    @$el.find('.main-profile-right-column').append(@profileTagsView.render().el)

    @profileContentHistoryView = new Customer.Users.ProfileContentHistoryView(search_query: @searchQuery)
    @$el.find('.main-profile-right-column').append(@profileContentHistoryView.render().el)

    @profileModerationChartView = new Customer.Users.ProfileModerationChartView(search_query: @searchQuery)
    @$el.find('.main-profile-right-column').append(@profileModerationChartView.render().el)

    # @profileTagsChartView = new Customer.Users.ProfileTagsChartView(search_query: @searchQuery)
    # @$el.find('.main-profile-right-column').append(@profileTagsChartView.render().el)
    return this

  isBeingModified: ->
    @profileAttributesView.isBeingModified()

  getSocialUserType: (socialUser) ->
    if socialUser.values.type in ['instagramComment', 'instagramMedia']
      'instagram'
    else if socialUser.values.type in ['TestYouTube', 'youtube']
      'youtube'
    else
      socialUser.values.type

  updateName: (name) =>
    @$el.find('.main-profile-name').text(name)

  unmergeSuccess: (response) ->
    @trigger('profile:social-user-removed', response)

  afterRender: =>
    @profileAttributesView.afterRender()

  _getName: ->
    profileName = @_getProfileName()
    if profileName?
      return profileName
    else
      @_getSocialUserName()

  _getProfileName: ->
    if @profile.values.name?
      return @profile.values.name unless Array.isArray(@profile.values.name)
      @profile.values.name[0].value

  _getSocialUserName: ->
    if @source.includes('instagram')
      source = 'instagram'
    else
      source = @source
    matchingSU = _.filter @socialUsers, (su) =>
      @getSocialUserType(su) == source
    matchingSU[0].values.name if matchingSU[0]?

  _orderSocialUsers: (socialUsers) ->
    return socialUsers unless socialUsers.length > 1
    firstUser = _.findWhere(socialUsers, {social_network_id: @socialId})
    anotherUsers = _.reject(socialUsers, {social_network_id: @socialId})

    if firstUser && anotherUsers
      orderedSocialUsers = _.union([firstUser], anotherUsers)
    else
      socialUsers
